import React, { FunctionComponent } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ButtonProps, EditButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { getCiEditCloudAssetContentPageHref } from "../../../../../../../AssetsRoutes";

export type EditCloudAssetContentButtonProps = ButtonProps;

export const EditCloudAssetContentButton: FunctionComponent<EditCloudAssetContentButtonProps> = ({ disabled }) => {
    const { assetId } = useParams<{ assetId: string }>();
    const history = useHistory();

    const moveToEditFileRecordContentPage = () => {
        const href = getCiEditCloudAssetContentPageHref(assetId);
        history.push(href);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={moveToEditFileRecordContentPage}
                disabled={disabled}
                label="Edit"
                isLabeled
                testId="edit-content"
            />
        </AuthorizationWrapper>
    );
};
